import { useLeadId as useAttributionLeadId } from '@/context/attributionContext'

import { isLeadIdPropagationEnabled } from '@/lib/utils/flags'

/**
 * Returns the current `lead_id` for URL propagation, or null when absent.
 *
 * Reads the in-memory id held by `AttributionProvider` (captured from the URL
 * on landing) — never from cookie / localStorage / sessionStorage (PECR
 * constraint, see WEB-903). Because the value comes from provider state that is
 * only set in an effect, server and first client render always agree (no
 * hydration mismatch).
 *
 * Gated behind NEXT_PUBLIC_LEAD_ID_PROPAGATION_ENABLED: when off, this is the
 * single chokepoint that returns null, making propagation a no-op everywhere
 * (TrackedLink, useTrackedRouter, and inline callers all read through here).
 */
export function useLeadId(): string | null {
  const leadId = useAttributionLeadId()
  return isLeadIdPropagationEnabled() ? leadId : null
}
